import {gql} from "apollo-boost";

export const ColorSchemeQuery = gql`
    query ColorScheme($institutionId: Int!) {
        colorScheme(institutionId:$institutionId) {
            fontFamily
            institutionId 
            institutionName
            adminEmail
            fontColorSupMenu
            menuColor
            scheduledId
        }
    }
`;